<template>
  <div class="menu_container">
    <div
      class="menu_item"
      :style="{ width: dataMaxCount % 4 === 0 ? '25%' : '20%' }"
      v-for="(item, index) in filterMenuData"
      :key="index"
      @click="skipHandle(item)"
    >
      <div class="item_img_wrapper">
        <img class="item_img" :src="item.dataImgUrl" />
        <span class="badge" v-if="badgeNum > 0 && item.dataJumpType === 11">
          {{ badgeNum > 99 ? '99+' : badgeNum }}
        </span>
      </div>
      <p class="item_text">{{ item.dataName }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { handleExternalUrl, isWeimobMallForMenu } from '@/utils/navigation'
import { isWechat } from '@/utils/weixin'
import { storeToRefs } from 'pinia'
import { useUsersStore } from '@/stores/users'
import { TabData } from '@/api/Models/AppTabs'

const props = defineProps<{
  data: LmsDecorateModule
  badgeNum: number
}>()

interface TItem {
  dataJumpType: number
  dataJumpUrl: string
  dataJumpId: string
}
const router = useRouter()

const usersStore = useUsersStore()
const { tabOptions } = storeToRefs(usersStore)
const hasLecturerNavgation = computed(() => {
  return tabOptions.value.find((item: TabData) => {
    return item.defaultCode === 'lecturer'
  })
})

const skipHandle = (item: TItem) => {
  switch (item.dataJumpType) {
    case 3: // 链接
      handleExternalUrl({ jumpUrl: item.dataJumpUrl })
      break
    case 8: // ceo
      router.push('/ceo')
      break
    case 11: // 我的任务
      localStorage.removeItem('isCnDriverAppSource')
      router.push('/task')
      break
    case 12: // 培训
      router.push('/myTraining')
      break
    case 13: // 课程
      router.replace('/course')
      break
    case 14: // 行业动态
      router.push('/broadcast')
      break
    case 15: // 社区
      router.replace('/community')
      break
    case 16: // 直播
      router.push('liveStream')
      break
    case 18: // 课程分类
      router.replace('/course?category=' + item.dataJumpId)
      break
    case 22: // 商城
      router.push('/shopIndex')
      break
    case 23: // 报名中心
      router.push('/applyCenter')
      break
    case 27: // 讲师中心
      hasLecturerNavgation.value ? router.replace('/lecturerCenterTab') : router.push('/lecturerCenter')
      break
    default:
      break
  }
}

const menuData = computed(() => {
  try {
    console.log('menuData')

    console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const filterMenuData = computed(() => {
  return menuData.value.filter((item: TItem) => {
    if (isWeimobMallForMenu(item) && isWechat) {
      return false
    }
    return true
  })
})
const dataMaxCount = computed(() => {
  return props.data.dataMaxCount
})
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.menu_container {
  margin: 12px 16px;
  padding: 6px 0 0;
  border-radius: 8px;
  background-color: @contentBackground;
  display: flex;
  flex-wrap: wrap;
  .menu_item {
    width: 20%;
    margin-bottom: 6px;
    flex-direction: column;
    .flex_center;
    .item_img_wrapper {
      position: relative;
    }
    .item_img {
      width: 50px;
      height: 50px;
      display: block;
      margin-bottom: 4px;
    }
    .badge {
      min-width: 16px;
      height: 16px;
      padding: 0 2px;
      font-size: 12px;
      background-color: #ef3838;
      border-radius: 16px;
      color: @textWhite;
      .flex_center;
      position: absolute;
      top: 0;
      right: -8px;
    }
    .item_text {
      width: 100%;
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>
